import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PageLayout } from '@cvx/nextpage';

@Component({
  selector: 'libEditorComponent',
  templateUrl: 'libEditor.component.html',
  styleUrls: ['./libEditor.component.css'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class LibEditorComponent {
  PageLayout = PageLayout;

  constructor(
    private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit(): void {
        
  }

}